import { Badge } from '../../Badge/Badge'
import { AvailabilityBadge } from '../../AvailabilityBadge/AvailabilityBadge'
import { BuildStatusBadge } from '../../BuildStatusBadge/BuildStatusBadge'
import { formatDate } from '../../../helpers/formatDate'
import type { ColumnDef } from '../../DataTable/DataTable'
import type { InventorySystemProfileDTO, TenantGroupDTO } from '../../../types'

export function buildInventorySystemProfilesTableColumns(
  tenantGroups: TenantGroupDTO[]
): ColumnDef<InventorySystemProfileDTO>[] {
  const groupById = new Map(tenantGroups.map((g) => [g.id, g]))

  return [
    {
      header: 'ID',
      sortValue: (p) => p.id,
      accessor: (p) => p.id,
      className: 'table-id-col text-end',
      cellClassName: 'font-monospace small',
    },
    {
      header: 'Code',
      sortValue: (p) => p.code,
      accessor: (p) => p.code,
      cellClassName: 'fw-medium',
    },
    {
      header: 'Name',
      sortValue: (p) => p.name,
      accessor: (p) => p.name,
    },
    {
      header: 'Type',
      sortValue: (p) => p.inventorySystemType,
      accessor: (p) => <Badge color="grey">{p.inventorySystemType}</Badge>,
    },
    {
      header: 'Build Schedule',
      sortValue: (p) => p.buildSchedule,
      accessor: (p) => <Badge color="grey">{p.buildSchedule}</Badge>,
    },
    {
      header: 'Build Status',
      sortValue: (p) => p.buildStatus,
      accessor: (p) => <BuildStatusBadge status={p.buildStatus} />,
    },
    {
      header: 'Availability Build',
      sortValue: (p) => p.availabilityBuildEnabled,
      accessor: (p) => (
        <AvailabilityBadge enabled={p.availabilityBuildEnabled} />
      ),
    },
    {
      header: 'Tenant Group',
      sortValue: (p) => groupById.get(p.tenantGroupId)?.code ?? p.tenantGroupId,
      accessor: (p) => {
        const code = groupById.get(p.tenantGroupId)?.code ?? p.tenantGroupId
        return <Badge color="grey">{code}</Badge>
      },
    },
    {
      header: 'Created',
      sortValue: (p) => p.createdAt,
      accessor: (p) => formatDate(p.createdAt),
    },
    {
      header: 'Updated',
      sortValue: (p) => p.updatedAt,
      accessor: (p) => formatDate(p.updatedAt),
    },
  ]
}
